import { normalizeGridSpec, type CharacterGridSpec } from "@/character/grid";

export type PublicEquippedShadow = {
  name: string;
  spritesheetDataUrl: string;
  grid: CharacterGridSpec;
  actions?: Record<string, string>;
};

export type DefenderShadowGameArt = {
  defenderShadowSpritesheetUrl: string;
  defenderShadowSpritesheetGrid: CharacterGridSpec;
  defenderShadowIdleTextureUrl: string;
};

export function parsePublicEquippedShadow(raw: unknown): PublicEquippedShadow | null {
  if (!raw || typeof raw !== "object") return null;
  const o = raw as Record<string, unknown>;
  const sheet = o.spritesheetDataUrl;
  if (typeof sheet !== "string" || !sheet.startsWith("data:")) return null;
  const gridRaw = o.grid;
  if (!gridRaw || typeof gridRaw !== "object") return null;
  const grid = normalizeGridSpec(gridRaw as CharacterGridSpec);
  const name =
    typeof o.name === "string" && o.name.trim() ? o.name.trim().slice(0, 48) : "ร่างเงา";
  const actions =
    o.actions && typeof o.actions === "object"
      ? (o.actions as Record<string, string>)
      : undefined;
  const idle = actions?.idle ?? sheet;
  return {
    name,
    spritesheetDataUrl: sheet,
    grid,
    actions: { ...actions, idle },
  };
}

export function defenderShadowToGameArt(
  shadow: PublicEquippedShadow | null | undefined,
): DefenderShadowGameArt | undefined {
  if (!shadow?.spritesheetDataUrl) return undefined;
  const idle = shadow.actions?.idle ?? shadow.spritesheetDataUrl;
  return {
    defenderShadowSpritesheetUrl: shadow.spritesheetDataUrl,
    defenderShadowSpritesheetGrid: shadow.grid,
    defenderShadowIdleTextureUrl: idle,
  };
}
